import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Some sections of a tabbed page now have their own address. A link to the old
// tab (?tab=<name>) opens that address, keeping the rest of the query. With
// noTabPage set, the bare page opens it too, as its first section did.
export const tabPageRedirect = (pages: Record<string, string>, noTabPage?: string): CanActivateFn => (route) => {
  const tab = route.queryParamMap.get('tab');
  const page = tab ? pages[tab] : noTabPage;
  if (!page) {
    return true;
  }
  const { tab: _tab, ...queryParams } = route.queryParams;
  return inject(Router).createUrlTree([page], { queryParams });
};
